import React from "react"
import {Button} from "@mui/material"
import AddIcon from "@mui/icons-material/Add"

import {CreateOfferModal} from "./CreateOfferModal/CreateOfferModal"
import {CreateOfferModalV2} from "./CreateOfferModal/CreateOfferModalV2"

type CreateOfferButtonProps = {
	enableCustomerOffersV2?: boolean
	minInstalmentAmount?: number
	balanceInCents?: number
}

function CreateOfferButton({
	enableCustomerOffersV2 = false,
	minInstalmentAmount = 10,
	balanceInCents = 0,
}: CreateOfferButtonProps) {
	const [createModalOpen, setCreateModalOpen] = React.useState(false)

	const handleSuccess = () => {
		setCreateModalOpen(false)
	}

	const ModalComponent = enableCustomerOffersV2 ? CreateOfferModalV2 : CreateOfferModal

	return (
		<>
			<Button
				variant="outlined"
				color="primary"
				startIcon={<AddIcon />}
				onClick={() => setCreateModalOpen(true)}
				size="small"
			>
				CREATE OFFER
			</Button>
			{createModalOpen && (
				<ModalComponent
					onClose={() => setCreateModalOpen(false)}
					onSuccess={handleSuccess}
					minInstalmentAmount={minInstalmentAmount}
					balanceInCents={balanceInCents}
				/>
			)}
		</>
	)
}

export {CreateOfferButton}
